import { z } from 'zod';

export const formSchema = z.object({
  observation: z.string().optional(),
  invoiceNumber: z.string({ required_error: 'Informe o número da NF' }).min(1, 'Informe o número da NF'),
});

export type FormSchema = z.infer<typeof formSchema>;